import * as React from "react"
import { Link } from "gatsby"
import { ClassNames } from "@storybook/theming"

export interface GatsbyLinkWrapperProps {
  className?: string
  children: React.ReactNode
  link: string
}

const GatsbyLinkWrapper: React.FC<GatsbyLinkWrapperProps> = ({
  className,
  children,
  link,
  ...props
}) => {
  const isHttpLink = link.startsWith("http")
  return isHttpLink ? (
    <a
      className={className}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </a>
  ) : (
    // <Link className={className} to={link} {...props}>
    <div className={className} {...props}>
      {children}
    </div>
    // </Link>
  )
}

export default GatsbyLinkWrapper
